import { Nes }                                  from '@/Emulator';
import { CpuFlag }                              from '@/Emulator/Hardware/CPU/CpuFlag';
import { IComponent }                           from '@/Interface/IComponent';
import { Component, h, Host, JSX, Prop, State } from '@stencil/core';

@Component({
    tag:      'nes-cpu-debugger',
    styleUrl: './nes-cpu-debugger.scss',
    shadow:   true,
})
export class NesCpuDebugger implements IComponent
{
    @Prop() public nes!: Nes;

    @State() private pc: number         = 0;
    @State() private sp: number         = 0;
    @State() private p: number          = 0;
    @State() private a: number          = 0;
    @State() private x: number          = 0;
    @State() private y: number          = 0;
    @State() private logLines: string[] = [];

    /**
     * @inheritDoc
     */
    public componentWillLoad(): void
    {
        let i = 0;
        this.nes.on('cycle', () => {
            i++;

            if ((i % 10000) === 0) {
                const dump    = this.nes.cpu!.dump();
                this.pc       = dump.pc;
                this.sp       = dump.sp;
                this.p        = dump.p;
                this.a        = dump.a;
                this.x        = dump.x;
                this.y        = dump.y;
                this.logLines = dump.log;
            }
        });
    }

    public render(): JSX.Element
    {
        return (
            <Host>
                <header>CPU</header>
                <div class="row">
                    <div class="card">
                        <div class="header">PC</div>
                        <div class="value">${this.pc.toString(16).padStart(4, '0')}</div>
                    </div>
                    <div class="card">
                        <div class="header">SP</div>
                        <div class="value">${this.sp.toString(16).padStart(4, '0')}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="card">
                        <div class="header">A</div>
                        <div class="value">{this.a.toString(10).padStart(3, '0')}</div>
                    </div>
                    <div class="card">
                        <div class="header">X</div>
                        <div class="value">{this.x.toString(10).padStart(3, '0')}</div>
                    </div>
                    <div class="card">
                        <div class="header">Y</div>
                        <div class="value">{this.y.toString(10).padStart(3, '0')}</div>
                    </div>
                </div>
                <div class="row flags">
                    <div class={{ active: (this.p & CpuFlag.Carry) !== 0 }}>Carry</div>
                    <div class={{ active: (this.p & CpuFlag.Zero) !== 0 }}>Zero</div>
                    <div class={{ active: (this.p & CpuFlag.InterruptDisable) !== 0 }}>InterruptDisable</div>
                    <div class={{ active: (this.p & CpuFlag.DecimalMode) !== 0 }}>DecimalMode</div>
                    <div class={{ active: (this.p & CpuFlag.Break) !== 0 }}>Break</div>
                    <div class={{ active: (this.p & CpuFlag.Overflow) !== 0 }}>Overflow</div>
                    <div class={{ active: (this.p & CpuFlag.Negative) !== 0 }}>Negative</div>
                </div>
                <div class="row log">
                    <pre>{this.logLines.join('\n')}</pre>
                </div>
            </Host>
        );
    }
}
